import { render, staticRenderFns } from "./profitReport.vue?vue&type=template&id=03946b44&"
import script from "./profitReport.vue?vue&type=script&lang=js&"
export * from "./profitReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports